<template>
  <section data-name="dashboard">
    <mega-load v-if="isLoading" />

    <template v-else>
      <section id="mapDisplay">
        <map-box :geopoints="geoPoints"
          :options="mapOptions" />
        <router-link id="bigMapBtn"
          to="/map">
          <button type="button">
            Enlarge Map
          </button>
        </router-link>
      </section>

      <section class="m-4">
        <dash-pulse :locations="locationsArray" />
      </section>

      <section class="m-4 pb-5">
        <dash-port-summary :locations="locationsArray" />
      </section>
    </template>
  </section>
</template>

<script>
import Mapbox from '@/components/map/mapbox'
import DashPulse from '@/components/dashboard/pulse'
import PortSummary from '@/components/dashboard/port-summary'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DashboardPage',

  components: {
    'map-box': Mapbox,
    'dash-pulse': DashPulse,
    'dash-port-summary': PortSummary,
  },

  data: () => {
    return {
      // geoPoints: {},
      mapOptions: {
        zoom: 1.2,
        closeOnClick: true,
        popoverAnchor: 'left',
        centrePoint: true,
      },
      loading: true,
    }
  },

  computed: {
    ...mapState('ecosystem', ['isLoading', 'locations']),
    locationsArray() {
      return Object.values(this.locations)
    },
    geoJSON() {
      const generateFeature = location => {
        const feature = {
          type: 'Feature',
          properties: {
            ...location,
            closeOnClick: true,
            popup: this.generatePopupHTML(location),
          },
          geometry: {
            type: 'Point',
            coordinates: [location.longitude, location.latitude, 0.0],
          },
        }
        return feature
      }

      const geoJSON = {
        type: 'FeatureCollection',
        features: [],
      }

      geoJSON.features = Object.keys(this.locations).map(locationId => {
        return generateFeature(this.locations[locationId])
      })

      return geoJSON
    },
    geoPoints() {
      return {
        source: {
          data: this.geoJSON,
          cluster: true,
          clusterMaxZoom: 10,
          clusterRadius: 15,
        },
        clusterShape: {
          type: 'circle',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': '#000000',
            'circle-radius': 10,
          },
        },
        clusterText: {
          type: 'symbol',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12,
            'text-allow-overlap': true,
          },
          paint: {
            'text-color': '#ffffff',
          },
        },
        pins: {
          type: 'symbol',
          filter: ['!', ['has', 'point_count']],
        },
      }
    },
  },

  created() {
    // return user to last location after auth
    const lastLocation = localStorage.getItem('_lastLocation')
    if (lastLocation) {
      localStorage.removeItem('_lastLocation')
      window.location.href = lastLocation
    }

    this.getLocations()
  },

  methods: {
    ...mapActions('ecosystem', ['getLocations']),
    generatePopupHTML(location) {
      const suburb = location.suburb ? location.suburb : ''
      return `
        <h3><a href="/services-by/location/${location.id}">${location.name} (${location.site_code})</a></h3>
        <strong>${location.status}</strong>
        <dl>
        <dt>Address</dt>
        <dd>${location.street} ${suburb} ${location.city} ${location.country}
        </dd>
        </dl>

        <h4>Services</h4>

        <table>
        <tr>
        <td width="40%">IX</td>
        <td>${location.services.IX}</td>
        </tr>
        <tr>
        <td>MCR</td>
        <td>${location.services.MCR}</td>
        </tr>
        <tr>
        <td>Megaports</td>
        <td>${location.services.MEGAPORT}</td>
        </tr>
        <tr>
        <td>VXCs</td>
        <td>${location.services.VXC}</td>
        </tr>
        </table>
          `
    },
  },
}
</script>

<style lang="scss" scoped>
#mapDisplay {
  width: 100%;
  height: 450px;
  position: relative;
  #bigMapBtn {
    position: absolute;
    top: 10px;
    left: 45px;
    button {
      margin-right: 1rem;
      padding: 1rem;
      cursor: pointer;
    }
  }
}
</style>
